module.exports = __webpack_public_path__ + "img/screenshot-in-frame.30754df3.png";